"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../theme");
const KPIContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 ${theme_1.theme.spacing(3)};
`;
const NumberAndUnit = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;
const Number = styled_components_1.default.div `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(7)};
  text-align: center;

  @media (max-width: ${theme_1.breakpoints.desktop}px) {
    ${theme_1.theme.fontSize(5)};
  }
  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    ${theme_1.theme.fontSize(4)};
  }
  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    ${theme_1.theme.fontSize(3)};
  }
`;
const Title = styled_components_1.default.div `
  ${theme_1.theme.fontBold};
  margin-top: ${theme_1.theme.spacing(2)};
  text-align: center;

  ${theme_1.theme.fontSize(1)};
  @media (max-width: ${theme_1.breakpoints.desktop}px) {
    ${theme_1.theme.fontSize(0)};
  }
  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    ${theme_1.theme.fontSize(-1)};
  }
`;
exports.default = ({ color, value, title, unit }) => {
    return ((0, jsx_runtime_1.jsxs)(KPIContainer, { children: [(0, jsx_runtime_1.jsxs)(NumberAndUnit, { children: [(0, jsx_runtime_1.jsx)(Number, { style: { color }, children: value ?? "N/A" }), unit && (0, jsx_runtime_1.jsx)("div", { children: unit })] }), (0, jsx_runtime_1.jsx)(Title, { children: title })] }));
};
